import request from '../../utils/request';
import { Search } from '@/DTOS/Labor/Search';

const LaborService = {
  search: (search: Search) => {
    return request('/labor/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; isActive: any; }} */ formData: {
      name: any;
      isActive: any;
    }
  ) => {
    return request('/labor/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          isActive: formData.isActive,
        },
      }),
    });
  },
};

export default LaborService;
